import { getBottomDockingHeight, getTopDockingHeight } from './getDockingHeight';
import DockingViewState from '../../../store/schema/DockingViewState';

const DEFAULT_MIN_BODY_HEIGHT = 100;

export default function createDockingViewState(
    isRibbonShown: boolean,
    isInlineCompose: boolean,
    isPopout?: boolean
): DockingViewState {
    return {
        isTopDocking: false,
        isBottomDocking: false,
        topDockingHeight: getTopDockingHeight(isInlineCompose),
        bottomDockingHeight: getBottomDockingHeight(isRibbonShown, isInlineCompose),
        minBodyHeight: DEFAULT_MIN_BODY_HEIGHT,
        scrollLeft: 0,
        scrollBarHeight: 0,
        dockingWidth: 0,
        bottomDockingBottom: 0,
        useStickyDocking: browserSupportSticky(),
        isPopout: isPopout,
    };
}

let supportSticky: { value: boolean } = null;

function browserSupportSticky() {
    if (!supportSticky) {
        supportSticky = {
            value:
                cssPropertyValueSupported('position', 'sticky') &&
                typeof IntersectionObserver == 'function',
        };
    }
    return supportSticky.value;
}

function cssPropertyValueSupported(prop: string, value: string) {
    const d = document.createElement('div');
    d.style[prop] = value;
    return d.style[prop] === value;
}
